module.exports = __webpack_public_path__ + "static/media/camera.bc570046.svg";